import React from "react";
import type { InputProps } from "./Input.types";

export const Input: React.FC<InputProps> = ({
  type = "text",
  placeholder,
  value,
  onChange,
  onBlur,
  disabled = false,
  error = false,
  className = "",
  name,
  id,
  required = false,
  autoComplete,
  ...props
}) => {
  const errorClasses = error ? "border-danger/50 ring-danger/30" : "";
  const dateClasses = type === "date" ? "[color-scheme:dark]" : "";
  const inputClasses = `sh-input ${errorClasses} ${dateClasses} ${className}`;

  return (
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
      className={inputClasses}
      name={name}
      id={id}
      required={required}
      autoComplete={autoComplete}
      {...props}
    />
  );
};
